module.exports = __webpack_public_path__ + "img/46.593d13e3.svg";